export default "__VITE_ASSET__B2u8y842__"